import { render } from "./HelpBenefits.vue?vue&type=template&id=58533436&scoped=true"
import script from "./HelpBenefits.vue?vue&type=script&lang=js"
export * from "./HelpBenefits.vue?vue&type=script&lang=js"

import "./HelpBenefits.vue?vue&type=style&index=0&id=58533436&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58533436"]])

export default __exports__